<template>
  <div>
    <v-container grid-list-md fluid text-xs-center class="pa-0">
      <v-layout row wrap align-center style="height:52vh;" class="scroll-y">
        <v-flex xs12 lg12>
          <div class="f-15 textColor w-100 text-xs-left font-weight-bold">Personal info</div>
        </v-flex>
        <v-flex xs12 lg3>
          <v-text-field
            required
            color="#749DBF"
            type="text"
            placeholder="First Name"
            class="textFeald"
            solo
            label="First Name"
            :rules="requiredRule"
            v-model="newUser.user.firstName"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 lg3>
          <v-text-field
            required
            color="#749DBF"
            type="text"
            placeholder="Last Name"
            class="textFeald"
            solo
            label="Last Name"
            :rules="requiredRule"
            v-model="newUser.user.lastName"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 lg3>
          <v-text-field
            color="#749DBF"
            type="text"
            maxlength="12"
            placeholder="Number plate"
            :rules="requiredRule"
            class="textFeald"
            solo
            label="Vehicle Number Plate"
            v-model="newUser.user.number_plate"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 lg3>
           <v-text-field
              color="#749DBF"
              type="text"
              placeholder="Pickup Location"
              class="textFeald"
              solo
              label="Pickup Location"
              v-model="newUser.user.pickup_location"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 lg3>
          <v-text-field
            required
            color="#749DBF"
            class="textFeald"
            solo
            prefix="+45"
            label="Phone Number"

            placeholder="Phone Number"
            maxlength="8"
            :rules="[ v => v.length >= 8 || 'Required to fill & It is 8 digits number']"
            v-model="newUser.user.phone"
          ></v-text-field>
        </v-flex>
        <!-- <v-flex xs12 lg4>
        <v-text-field
          required
          color="#749DBF"
          class="textFeald date"
          type="date"
          solo
          v-model="birthday"
        ></v-text-field>
        </v-flex>-->

        <v-flex xs12 lg6 class="mb-3">
          <v-flex xs12 class="white shadow-1">
            <div class="f-9 pl-1 w-100 text-xs-left textColor font-weight-bold">Personal info</div>

            <div class="ma-0 pt-1 pl-2 white w-100">
              <date-dropdown
                :max="this.$root.getDaisableDate(16)"
                :min="this.$root.getDaisableDate(90)"
                v-model="newUser.user.dob" />
            </div>
          </v-flex>
        </v-flex>


        <v-flex xs12 lg6 class="mb-3">
          <v-flex xs12 class="white shadow-1">
            <div slot="label-top" class="active ml-2 text-xs-left w-100 text-primary f-9 pt-2">Address</div>
            <vue-dawa
              @select="selectItems($event, 'newUseraddresss')"
              :val="newUseraddresss.oneLineAddress"
              :showMax="5"
              containerId="teaAddresss_container"
              fieldId="teaAddresss_id"
              fieldName="teaAddresss_name"
              placeholder="Address"
            >
            </vue-dawa>
          </v-flex>
        </v-flex>
        <!-- <v-flex xs12 lg4>
          <v-select
            :items="gender"
            class="input-group--focused"
            label="Gender"
          ></v-select>
        </v-flex>-->
        <v-flex xs12 lg6 offset-xs0 class="mb-3">
          <v-flex xs12 class="white shadow-1">
            <div class=" ml-2 f-12 text-xs-left textColor w-100  text-left">Gender</div>
            <v-radio-group
              v-model="newUser.user.gender"
              style="margin-bottom: -23px!important;"
              row
              class="ma-0"
            >
              <v-radio color="primary" label="Male" value="male"></v-radio>
              <v-radio color="primary" label="Female" value="female"></v-radio>
              <v-radio color="primary" label="Non-binary" value="non_binary"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-flex>

        <v-flex xs12 lg6>
          <v-text-field
            required
            color="#749DBF"
            class="textFeald"
            solo
            label="Club name"
            placeholder="Club name"
            v-model="newUser.user.clubName"
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex xs12 lg6>
          <v-text-field solo
                        name="Email"
                        label="Email"
                        :rules="emailRules"
                        v-model="newUser.user.email"
                        class="input-group--focused"
                        required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 lg6>
          <v-text-field
            required
            color="#749DBF"
            class="textFeald"
            type="password"
            solo
            label="Password"
            :rules="passwordRule"
            placeholder="Password"
            v-model="newUser.user.password"
          ></v-text-field>
        </v-flex>
        <v-flex lg3 xs6 sm4>
          <div class="f-15 text-xs-left textColor w-100 font-weight-bold text-xs-left">Upload Profile Picture</div>
          <input
            type="file"
            style="display:none"
            ref="ImgInput"
            accept="image/*"
            @change="onImgPicked"
          >
          <v-layout>
            <v-flex>
              <div class="w-100">
                <v-btn
                  class="card-r left"
                  outline
                  @click="onPickImg"
                >Upload</v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="br-2 pa-3 " v-if="this.newUser.user.profileImgPreview[0]">
              <div class="w-100 text-xs-right">
                <v-btn icon color="grey lighten-2"><v-icon>close</v-icon></v-btn>
              </div>
              <v-img
                :src="this.newUser.user.profileImgPreview[0]"
                :lazy-src="n"
                aspect-ratio="1"
                v-if="this.newUser.user.profileImgPreview[0]"
                class="grey lighten-2 h-150  "
              >
                <v-layout
                  slot="placeholder"
                  fill-height
                  align-center
                  justify-center
                  ma-0
                >
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </v-img>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- ---------------------- Schedule Part - Start-------------------- -->
        <v-flex class="text-xs-center pt-3" xs12 sm12 lg12 style="margin:auto">
          <v-flex xs12 lg12>
            <div class="f-15 textColor text-xs-left font-weight-bold">Customize Teacher Schedule</div>
          </v-flex>

              <v-flex xs12 class="text-xs-left">

                        <v-tabs class="text-xs-center transparent" slot="extension" v-model="tab" >
                          <v-tabs-slider color="unset"></v-tabs-slider>

                          <v-tab href="#tab-1" class="  " @click="setSelectedTab(0)">
                            <v-avatar color="primary darken-2" size="40px">
                              <span class="f-12 font-weight-regular white--text" >M</span>
                            </v-avatar>
                          </v-tab>

                          <v-tab href="#tab-2" class="  " @click="setSelectedTab(1)">
                            <v-avatar color="primary darken-2" size="40px">
                              <span class="f-12 font-weight-regular white--text">T</span>
                            </v-avatar>
                          </v-tab>

                          <v-tab href="#tab-3" class="  "  @click="setSelectedTab(2)">
                            <v-avatar color="primary darken-2" size="40px">
                              <span class="f-12 font-weight-regular white--text">W</span>
                            </v-avatar>
                          </v-tab>
                          <v-tab href="#tab-4" class="  " @click="setSelectedTab(3)">
                            <v-avatar color="primary darken-2" size="40px">
                              <span class="f-12 font-weight-regular white--text" >T</span>
                            </v-avatar>
                          </v-tab>

                          <v-tab href="#tab-5" class="  " @click="setSelectedTab(4)">
                            <v-avatar color="primary darken-2" size="40px">
                              <span class="f-12 font-weight-regular white--text" >F</span>
                            </v-avatar>
                          </v-tab>

                          <v-tab href="#tab-6" class="  " @click="setSelectedTab(5)">
                            <v-avatar color="primary darken-2" size="40px">
                              <span class="f-12 font-weight-regular white--text" >S</span>
                            </v-avatar>
                          </v-tab>
                          <v-tab href="#tab-7" class="  " @click="setSelectedTab(6)">
                            <v-avatar color="primary darken-2" size="40px">
                              <span class="f-12 font-weight-regular white--text" >S</span>
                            </v-avatar>
                          </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab" class="transparent">
                          <v-tab-item  v-for="(index,i) in teacherClasses" :value="'tab-' + (i+1)" :key="i">
                            <v-card flat class="grey lighten-4">
                              <v-flex xs12 class="checkbox pa-0">

                                <v-checkbox
                                  v-if="i!=0"
                                  label="Repeat the schedule as Monday/First day"
                                  required
                                  v-model="SameSchedule[i]"
                                  @change="setSameSchedule(0,i)"
                                ></v-checkbox>
                              </v-flex>
                              <span class="f-15 textColor font-weight-bold">Add Your Class Schedule</span>
                              <div class="list-dbg">
                                <v-layout xs12 class="">
                                  <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                                    <span class="f-12 font-weight-bold text-primary">Start Hour</span>
                                    <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarr-'+i+'-0-A'">
                                      <!-- <div v-for="num in 24" :id="'checkNum-'+num" :key="num.id" @mouseover="setHour(num)"> -->
                                      <div v-for="num in 24" :id="'checkNum-'+num" :key="num.id" @mouseover="setHour(num)">
                                        <!-- <div @mousewheel="Output(num)"> -->
                                        {{num-1}}
                                        <!-- </div> -->
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                                    <span class="f-12 font-weight-bold text-primary">Min</span>
                                    <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarr-'+i+'-0-B'">
                                      <div>00</div>
                                      <div>15</div>
                                      <div>30</div>
                                      <div>45</div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                                    <span class="f-12 font-weight-bold text-primary">Work Min</span>
                                    <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarr-'+i+'-0-C'">
                                      <div class="">00</div>
                                      <div class="">45</div>
                                      <div class="">90</div>
                                      <div class="">135</div>
                                      <div class="">180</div>
                                      <div class="">225</div>
                                      <div class="">270</div>
                                    </div>
                                  </v-flex>
                                  <!--<v-flex xs1 class=" text-xs-center ">-->
                                  <v-avatar :size="25" class="" color="primary darken-2"  v-on:click="counter -= 1">
                                    <v-icon dark class="f-8 white--text">close</v-icon>
                                  </v-avatar>
                                  <!--</v-flex>-->
                                </v-layout>
                                <v-layout>
                                  <v-flex>

                                    <div v-if="error_in[0][0]==true" style="color:white;background-color:red;padding:5px;">
                                      Your selected time is overlapping with another schedule
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </div>
                              <div class="list-dbg mt-2 mb-2" v-for="n in counter[i]" :key="n">

                                <v-layout xs12 class="">

                                  <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                                    <span class="f-12 font-weight-bold text-primary">Start Hour</span>
                                    <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarr-'+i+'-'+n+'-A'">
                                      <div v-for="num in 24" :id="'checkNum-'+num" :key="num.id" @mouseover="setHour(num)">
                                        <!-- <div v-for="i in 24" :key="i.id" @change="hour(i)">{{i}} -->
                                        {{num-1}}
                                      </div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                                    <span class="f-12 font-weight-bold text-primary">Min</span>
                                    <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarr-'+i+'-'+n+'-B'">
                                      <div>00</div>
                                      <div>15</div>
                                      <div>30</div>
                                      <div>45</div>
                                    </div>
                                  </v-flex>
                                  <v-flex xs4 lg2 offset-xs0 class="text-xs-center pa-1">
                                    <span class="f-12 font-weight-bold text-primary">Work Min</span>
                                    <div class="containerr y proximity-scroll-snapping " dir="ltr" :id="'scrollBarr-'+i+'-'+n+'-C'">
                                      <div class="">00 </div>
                                      <div class="">45 </div>
                                      <div class="">90 </div>
                                      <div class="">135 </div>
                                      <div class="">180 </div>
                                      <div class="">225</div>
                                      <div class="">270</div>
                                    </div>
                                  </v-flex>
                                  <v-avatar :size="25" class="" color="primary darken-2"  v-on:click="counter[i] -= 1">
                                    <v-icon dark class="f-8 white--text">close</v-icon>
                                  </v-avatar>
                                </v-layout>
                                <v-layout>
                                  <v-flex>
                                    <div v-if="error_in[i][n]==true" style="color:white;background-color:red;padding:5px;">
                                      Your selected time is overlapping with another schedule
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </div>
                              <span class="f-15 textColor font-weight-bold">Add More Schedule</span>

                              <v-layout >

                                <v-flex xs2 class="pa-2">
                                  <v-avatar :size="40" color="primary darken-2"  v-on:click="addSlot(i)">
                                    <v-icon dark class="f-12 font-weight-regular white--text">add</v-icon>
                                  </v-avatar>
                                  <br>

                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-flex>
              <div class="f-15 textColor w-100 text-xs-left font-weight-bold">Duration</div>

              <v-layout xs12 class="">
                <v-flex xs12 lg4 class="pa-1">
                  <div class="f-12 text-xs-left text-primary w-100 font-weight-bold pa-0">Start Date</div>
                  <Datepiker v-on:setDate="setStartDate"/>
                  <!--<VueCtkDateTimePicker v-model="yourValue" />-->
                  <!--<vue-ctk-date-time-picker></vue-ctk-date-time-picker>-->
                </v-flex>
                <v-flex xs12 lg4 class="pa-1">
                  <div class="f-12 text-xs-left w-100 text-primary font-weight-bold">End Date</div>
                  <Datepiker v-on:setDate="setEndDate"/>
                  <!--<VueCtkDateTimePicker v-model="yourValue" />-->
                </v-flex>
              </v-layout>
              <v-alert
                :value="true"
                v-if="validationMsg"
                type="info">
                {{validationMsg}}
              </v-alert>
              <v-alert
                :value="true"
                v-if="errorMessage"
                type="error">
                {{errorMessage}}
              </v-alert>
              <v-flex xs12  >
                <!-- <v-btn slot="activator" @click="checkDates" class="no-shadow card-r w-100 ma-0 mainBackG text--white btnM">Create Schedule</v-btn> -->
                <v-dialog  class="pa-0 display-unset" v-model="dialog" width="500">



                  <!--<div center class="text-xs-center">-->
                  <!--<v-avatar color="primary cercle" size="97" >-->
                  <!--<v-icon dark class="f-100">check_circle</v-icon>-->
                  <!--</v-avatar>-->
                  <!--<v-icon class="mb-5"></v-icon>-->
                  <!--</div>-->
                  <v-card class=" card-r no-shadow pa-3">
                    <div  class=" text-xs-center">
             <span class="f-20">
                Are you sure?
             </span>
                    </div>
                    <v-layout>
                      <v-flex>
                        <!-- <v-flex xs12 class=""> -->
                        <!-- <v-list>

                          <v-card color="grey lighten-2" class="mt-2 pa-1 mb-2 card-r no-shadow">
                            <v-list-tile>
                              <v-list-tile-action>
                                <v-icon color="primary" class="f-30">fas fa-check-circle</v-icon>
                              </v-list-tile-action>

                              <v-list-tile-content>
                                <v-list-tile-title>Mr . Adam</v-list-tile-title>
                              </v-list-tile-content>

                            </v-list-tile>
                          </v-card>
                          <v-card color="grey lighten-2" class="mb-2 pa-1 card-r no-shadow">
                            <v-list-tile>
                              <v-list-tile-action>
                                <v-icon color="primary" class="f-30">fas fa-check-circle</v-icon>
                              </v-list-tile-action>

                              <v-list-tile-content>
                                <v-list-tile-title>135 hours</v-list-tile-title>
                              </v-list-tile-content>

                            </v-list-tile>
                          </v-card>
                          <v-card color="grey lighten-2" class="mb-2 pa-1 card-r no-shadow">
                            <v-list-tile>
                              <v-list-tile-action>
                                <v-icon color="primary" class="f-30">fas fa-check-circle</v-icon>
                              </v-list-tile-action>

                              <v-list-tile-content>
                                <v-list-tile-title>3 classes</v-list-tile-title>
                              </v-list-tile-content>

                            </v-list-tile>
                          </v-card>
                        </v-list> -->

                        <!-- </v-flex> -->

                        <v-layout xs12>
                          <v-flex xs12 class="text-xs-left mr-1">
                            <v-btn @click="dialog = false" color="grey" class="w-100 text-white card-r no-shadow ma-0">Cancel</v-btn>
                          </v-flex>
                          <v-flex xs12 class="text-xs-right ml-1">
                            <v-btn @click="createSchedule" class="w-100 card-r primary darken-2 text-white no-shadow card-r ma-0">Confirm</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-flex>
                      <v-alert
                        :value="true"
                        v-if="alertType=='success'"
                        type="success">
                        {{msg}}
                      </v-alert>
                      <v-alert
                        :value="true"
                        v-if="alertType=='warning'"
                        type="error">
                        {{msg}}
                      </v-alert>
                    </v-flex>
                    <v-flex class="text-xs-center pt-9" xs12 sm12 lg9 style="margin:auto">
                      <pulse-loader :loading="
                        loading" :color="'#004d98'"></pulse-loader>
                    </v-flex>
                  </v-card>
                </v-dialog>


              </v-flex>
              <!-- <v-flex xs12   class="mt-2">
                <div class="text-xs-center">
                  <router-link to="/teacher" class="f-15 text-xs-right">Skip</router-link>
                </div>
              </v-flex> -->
            </v-flex>
        <v-flex lg12 xs12 sm12>
          <v-progress-circular
            indeterminate
            v-if=loading
            color="primary darken-2"
          ></v-progress-circular>
          <v-alert
            :value="true"
            color="success"
            icon="check_circle"
            v-if="alert.type=='success'"
            outline
          >
            {{alert.msg}}
          </v-alert>
          <v-alert
            :value="true"
            color="error"
            icon="warning"
            v-if="alert.type=='warning'"
            outline
          >
            {{alert.msg}}
          </v-alert>

        </v-flex>
        <v-flex lg12 xs12 sm12>
          <v-btn
            class="card-r no-shadow right"
            color="primary darken-2"
            @click="addTeacher"
          >Save</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

  </div>

</template>

<script>
/* eslint-disable */
import api from '../../../utils/backend-api.js'
import Datepiker from "../Datepicker";
import { mapState, dispatch } from "vuex";
import VueDawa from "vue-dawa";
import DateDropdown from 'vue-date-dropdown'
//import router from '../router';
import router from '@/router'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: "AddNewStudent",
  data: () => ({
    tab: null,
    newUseraddresss: {
      oneLineAddress: ""
    },
    todayDate:'',
    emailRules: [
				v => !!v || "E-mail is required",
				v =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					"E-mail must be valid"
      ],
      passwordRule: [
				v => !!v || "Password is required",
				v => (v && v.length > 6) || "Password must be grater than 8 characters & includes lower case, upper case & special characters"
      ],
    newUser: {
      userType: "dsfdfd",
      user: {
        firstName: "",
        lastName: "",
        phone: "",
        dob: "",
        number_plate:'',
        pickup_location:'',
        address: {
          oneLineAddress: ""
        },
        gender: "",
        clubName: "",
        email: "",
        password: "",
        termAccept: "",
        profileImage:[],
        profileImgPreview:[]
      },
      teacherClasses: {
        day:['MON','TUE','WED','THU','FRI','SAT','SUN'],
        time:[
              [{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''}],
              [{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''}],
              [{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''}],
              [{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''}],
              [{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''}],
              [{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''}],
              [{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''},{type:'',timefrom:'',hours:''}],
            ],
        date_from:'',
        date_to:'',
      },
    },
    teacherClasses:[
      ["MON",[[]]],
      ["TUE",[[]]],
      ["WED",[[]]],
      ["THU",[[]]],
      ["FRI",[[]]],
      ["SAT",[[]]],
      ["SUN",[[]]],
    ],
    ClassTime:[],
    classType:[],
    startDate:'',
    endDate:'',
    requiredRule: [v => !!v || "This field is required"],
    menu:false,
    counter: {
      0:0,
      1:0,
      2:0,
      3:0,
      4:0,
      5:0,
      6:0,
    },
    SameSchedule:[],
    seen: true,
    show: true,
    // yourValue: '',
    date: null,
    birthday: false,
    type: ["Student", "Teacher"],
    gender: ["male", "female","non-binary"],

    workMin: [
      "45",
      "90",
      "135",
      "180",
    ],
    breakmin: ["15 min", "30 min", "45 min", "60 min"],

    alert:{
      type:'',
      msg:''
    },
    dialog:false,
    scrollPositions:[
      [],
      [],
      [],
      [],
      [],
      [],
      []
    ],
    timeslot: [[[
      {time:"07:00 am",value:'07:00'},
      {time:"07:45 am",value:'07:45'},
      {time:"08:30 am",value:'08:30'},
      {time:"09:15 am",value:'09:15'},
      {time:"10:00 am",value:'10:00'},
      {time:"11:45 pm",value:'11:45'},
      {time:"12:30 pm",value:'12:30'},
      {time:"01:15 pm",value:'01:15'},
      {time:"02:00 pm",value:'02:00'},
      {time:"03:45 pm",value:'03:45'},
      {time:"04:30 pm",value:'04:30'},
      {time:"05:15 pm",value:'05:15'}]]
    ],
    tempValue:'',
    selectedTab:0,
    selectedTime:[],
    date_from:'',
    date_to:'',
    loading:false,
    alertType:'',
    msg:'',
    validationMsg:'',
    errorMessage:'',
    error_in:[
      [],
      [],
      [],
      [],
      [],
      [],
      []
    ],

  }),
  watch: {},
  created() {
    this.todayDate= new Date().toISOString().slice(0,10)
    this.newUser.user.clubName=Store.state.user.club_name
    var timeslot=[[
      {time:"07:00 am",value:'07:00'},
      {time:"07:45 am",value:'07:45'},
      {time:"08:30 am",value:'08:30'},
      {time:"09:15 am",value:'09:15'},
      {time:"10:00 am",value:'10:00'},
      {time:"10:45 am",value:'10:45'},
      {time:"11:30 am",value:'11:30'},
      {time:"12:15 pm",value:'12:15'},
      {time:"01:00 pm",value:'01:00'},
      {time:"01:45 pm",value:'01:45'},
      {time:"02:30 pm",value:'02:30'},
      {time:"03:15 pm",value:'03:15'},
      {time:"04:00 pm",value:'04:00'},
      {time:"04:45 pm",value:'04:45'},
      {time:"05:30 pm",value:'05:30'}]]

      for(var x=0;x<7;x++){
        this.timeslot[x]=timeslot
      }

  },
  updated:function(){
    this.setTeacherTime()
  },
  methods: {
    addSlot(i){
        this.saveScrollPositions()
        this.counter[i] += 1
        this.setNewSlotValues(parseInt(this.counter[this.selectedTab]-1))
    },
    setNewSlotValues(i){
          console.log(i)
          // console.log(this.scrollPositions)
          console.log(this.scrollPositions[this.selectedTab][this.counter[i]-1])
          let selectedHourPosition=(this.scrollPositions[this.selectedTab][parseInt(this.counter[this.selectedTab]-1)]).Hour
          let selectedHourValue=selectedHourPosition=("0"+(parseInt((selectedHourPosition+100)/100)-1)).slice(-2)
          let selectedMinPosition=this.scrollPositions[this.selectedTab][this.counter[this.selectedTab]-1].Min
          let selectedMinValue=(parseFloat('0.'+(((parseInt((selectedMinPosition+100)/100))-1)*15)%60).toFixed(2)).substring(2,4)
          let SelectedTime=selectedHourValue+':'+selectedMinValue+":00"
          var datetime = new Date('1970-01-01T' + SelectedTime);
          // let Data=Date.parse(SelectedTime)

          let SelectedWorkMinPosition=this.scrollPositions[this.selectedTab][this.counter[this.selectedTab]-1].workMin
          let selectedWorkMinValue=(parseInt((SelectedWorkMinPosition+100)/100)-1)*45

          let newDateTime= new Date(datetime.getTime() + selectedWorkMinValue*60000);
          let newTime=newDateTime.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
          let newHourPosition=((parseInt(newTime.substring(0,2))+1)*100)-100
          let newMinPosition=((newTime.substring(3,5)*100)/15)
          let newPositions={
                  Hour:newHourPosition,
                  Min:newMinPosition,
                  workMin:SelectedWorkMinPosition
                }


          this.scrollPositions[this.selectedTab][this.counter[this.selectedTab]]=newPositions
    },
    onPickImg(){
        this.$refs.ImgInput.click();

    },
    onImgPicked(){
        this.newUser.user.profileImgPreview=[]
        const files = event.target.files
        this.newUser.user.profileImage=files[0]
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.addEventListener("load", () => {
          this.newUser.user.profileImgPreview.push(fileReader.result)
        });
    },
    changeTimeSlot(time,day,timeIndex,timeFrom){
      let timeBlock=0;
      for(var x=0;x<this.timeslot[day][timeIndex].length;x++){
          if(this.timeslot[day][timeIndex][x].value==timeFrom){
                timeBlock+=x
          }
      }

      for(var x=0;x<this.workMin.length;x++){
        if(this.workMin[x]==time){
          timeBlock+=x
          break;
        }
      }
      let newtimeslot=[]
      for(var x=0;x<this.timeslot[day][timeIndex].length;x++){
        if(x>timeBlock){
            newtimeslot.push(this.timeslot[day][timeIndex][x])
        }
      }
      this.timeslot[day][timeIndex+1]=newtimeslot
    },
    addTeacher() {
      this.loading=true
      this.alert.type=""

      if(this.loading==true){
          var Teacher = {
              name: this.newUser.user.firstName+' '+this.newUser.user.lastName,
              email: this.newUser.user.email,
              phone: this.newUser.user.phone,
              dob: (this.newUser.user.dob).substring(6,11)+'-'+(this.newUser.user.dob).substring(3,5)+'-'+(this.newUser.user.dob).substring(0,2),
              numberPlate: this.newUser.user.number_plate,
              pickup_location: this.newUser.user.pickup_location,
              address: this.newUseraddresss.oneLineAddress,
              city: this.newUseraddresss.city,
              state: this.newUseraddresss.state,
              zipCode: this.newUseraddresss.zipCode,
              gender: this.newUser.user.gender,
              role: "teacher",
              password: this.newUser.user.password,
              image:this.newUser.user.profileImage
          };
          var formData=new FormData()
          formData.append("name",Teacher.name)
          formData.append("email",Teacher.email)
          formData.append("phone",Teacher.phone)
          formData.append("number_plate",Teacher.numberPlate)
          formData.append("pickup_location",Teacher.pickup_location)
          formData.append("dob",Teacher.dob)
          formData.append("address",Teacher.address)
          formData.append("city",Teacher.city)
          formData.append("state",Teacher.state)
          formData.append("zipCode",Teacher.zip)
          formData.append("gender",Teacher.gender)
          formData.append("role",Teacher.role)
          formData.append("password",Teacher.password)
          formData.append("image",Teacher.image)
          this.$store.dispatch("Teachers/AddTeacher", formData)
          .then(res => {

            let teacherId=res.data.user.id
            this.createSchedule(teacherId)

          }).catch(error=>{
            this.loading=false
            this.alert.type="warning"
            this.alert.msg="Check your details and try again"
          });
      }else{
        this.loading=false
        this.alert.type="warning"
        this.alert.msg="Accept the Terms and Policies to continue"
      }
    },
    setScrollPositions(currentindex){
        // debugger
        let cnt=this.counter[currentindex]
        setTimeout(()=>{
          // debugger
          console.log(this.scrollPositions)
          let self=this
          // if(self.scrollPositions){
            for(let x=0;x<=cnt;x++){
                // debugger
                if(self.scrollPositions[currentindex].length>0){
                  // console.log(self.scrollPositions[currentindex])
                  var positionHour = document.getElementById('scrollBarr-'+currentindex+"-"+x+"-A");
                  positionHour.scrollTo(0,self.scrollPositions[currentindex][x].Hour)
                  var positionMin = document.getElementById('scrollBarr-'+currentindex+"-"+x+"-B");
                  positionMin.scrollTo(0,self.scrollPositions[currentindex][x].Min)
                  var positionWorkMin = document.getElementById('scrollBarr-'+currentindex+"-"+x+"-C");
                  positionWorkMin.scrollTo(0,self.scrollPositions[currentindex][x].workMin)
                  console.log(positionHour.scrollTop,'-',positionMin.scrollTop,'-',positionWorkMin.scrollTop)
                }
            }
          // }
        },500);
    },
    setTeacherSchedule(teacherId){
        let day=[];
        let times=[];
        const teacherClasses=this.teacherClasses


        for(var x=0;x<7;x++){
          var length=teacherClasses[x][1].length
          if(teacherClasses[x][1][0].type){
              day.push(teacherClasses[x][0])
              times.push(teacherClasses[x][1])
          }
        }

        var ScheduleData=[];
        ScheduleData.push(day,times,this.startDate,this.endDate,teacherId)
        // this.$store.dispatch("Teachers/setTeachersSchedule",ScheduleData)


        for(var x=0;x<ScheduleData[1].length;x++){
          var length=ScheduleData[1][x].length
          for(var y=0;y<length;y++){
              ScheduleData[1][x][y]=Object.assign({},ScheduleData[1][x][y])
          }
        }
        var passingData={
          day:ScheduleData[0],
          times:ScheduleData[1],
          date_from:ScheduleData[2],
          date_to:ScheduleData[3],
          teacher_id:ScheduleData[4],
        }
        api.postData("admin/calender/teacher/create",passingData)
        .then(res => {
          if(res.status==201){
              this.loading=false
              this.alert.type="success"
              this.alert.msg="Teacher created successfully"
              setTimeout(() => {
                this.$router.push('/teachers')
              }, 1200);
          }
        })
        .catch(function (error) {
              this.loading=false
              this.alert.type="success"
              this.alert.msg="️Teacher Created Successfully. Schedule Not created"
        })

    },
    selectItems(payload, objectName) {
      this.$set(this, objectName, this.translateData(payload));
      // this.newUser.user.address = this.translateData(payload);
    },
    translateData(address) {
      if (!address || !address.data) {
        return;
      }
      return {
        id: address.data.id,
        street: address.data.vejnavn,
        streetNumber: address.data.husnr,
        floor: address.data.etage,
        door: address.data.dør,
        zipCode: address.data.postnr,
        city: address.data.postnrnavn,
        oneLineAddress: address.tekst
      };
    },
    setStartDate(value){
      this.date_from=value
    },
    setEndDate(value){
      this.date_to=value
    },
    setSelectedTab(num){
      this.setTeacherTime()
      this.saveScrollPositions()
      this.selectedTab=num
      console.log(this.selectedTab)
    },
    setSameSchedule(beforindex,currentindex){
      if(this.SameSchedule[currentindex]==true){

        this.selectedTime[currentindex]=this.selectedTime[beforindex]
        this.scrollPositions[currentindex]=this.scrollPositions[beforindex]
        this.counter[currentindex]=this.counter[beforindex]
      }
      console.log("beforindex: ",beforindex)
      let cnt=this.counter[currentindex]
      setTimeout(()=>{
          for(let x=0;x<=cnt;x++){
            // debugger
              console.log(this.scrollPositions[0][x])
              var positionHour = document.getElementById('scrollBarr-'+currentindex+"-"+x+"-A");
              positionHour.scrollTo(0,this.scrollPositions[0][x].Hour)
              var positionMin = document.getElementById('scrollBarr-'+currentindex+"-"+x+"-B");
              positionMin.scrollTo(0,this.scrollPositions[0][x].Min)
              var positionWorkMin = document.getElementById('scrollBarr-'+currentindex+"-"+x+"-C");
              positionWorkMin.scrollTo(0,this.scrollPositions[0][x].workMin)
              console.log(positionHour.scrollTop,'-',positionMin.scrollTop,'-',positionWorkMin.scrollTop)
          }
      },200);
    },
    saveScrollPositions(){
      // debugger
      let currentTab=this.selectedTab
      let arr=[]
      // for(let y=0;y<7;y++){
        arr=[]
        let count=this.counter[currentTab]
        for(let x=0;x<=count;x++){
          var positionHour = document.getElementById('scrollBarr-'+currentTab+"-"+x+"-A");
          var positionMin = document.getElementById('scrollBarr-'+currentTab+"-"+x+"-B");
          var positionWorkMin = document.getElementById('scrollBarr-'+currentTab+"-"+x+"-C");
          let positions={
            Hour:positionHour.scrollTop,
            Min:positionMin.scrollTop,
            workMin:positionWorkMin.scrollTop,
          }

          arr.push(positions)
          this.scrollPositions[currentTab]=arr
        }
      // }
      console.log(this.scrollPositions)
    },
    setHour(num){

      this.tempValue=num
    },
    setTeacherTime(){

        let i=this.selectedTab
        let tempTime=[]
        for(let x=0;x<=this.counter[i];x++){
          try{
            var positionHour = document.getElementById('scrollBarr-'+i+"-"+x+"-A");
            var positionMin = document.getElementById('scrollBarr-'+i+"-"+x+"-B");
            var positionWorkMin = document.getElementById('scrollBarr-'+i+"-"+x+"-C");

            let time={
              time_from:("0"+(parseInt((positionHour.scrollTop+100)/100)-1)).slice(-2)+':'+(parseFloat('0.'+(((parseInt((positionMin.scrollTop+100)/100))-1)*15)%60).toFixed(2)).substring(2,4),
              hours:(parseInt((positionWorkMin.scrollTop+100)/100)-1)*45,
              type:'work'
            }
            tempTime.push(time)
          }catch(err){

          }
        }
        this.selectedTime[i]=tempTime
        // console.log(this.selectedTime)
        // console.log('-----------------------')
      // }
      // console.log("\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n");

    },
    checkDates(){
      this.validationMsg=''
      // debugger
      console.log(this.date_from)
      console.log(this.date_to)
      // if(!this.date_from || !this.date_to){
      //   this.dialog=false
        // this.validationMsg="Please choose date"
      // }else{
        this.dialog=true
      // }
    },
    createSchedule(teacherId){
        this.error_in=[[],[],[],[],[],[],[]]
        this.loading=true
        this.alertType=""
        this.msg=""
        this.errorMessage=""
        // let TeacherId=Store.state.user.id
        // debugger
        let Data
        if(this.date_to && this.date_from){
          Data ={
            day:['MON','TUE','WED','THU','FRI','SAT','SUN'],
            times:this.selectedTime,
            date_from:this.date_from,
            date_to:this.date_to,
            teacher_id:teacherId
          }
        }else{
          Data ={
            day:['MON','TUE','WED','THU','FRI','SAT','SUN'],
            times:this.selectedTime,
            teacher_id:teacherId
          }
        }
        let self=this
        api.postData('admin/calender/teacher/create',Data)
        .then(res=>{
              console.log(res)
              if(res.status==201){
                this.loading=false
                this.alertType="success"
                this.msg="you Have Successfully create your schedule"
                setTimeout(()=>{
                  router.push('/teachers')
                },2000);
              }
        }).catch(error=>{
                this.loading=false


                console.log(error)
                if (error.response.data.error) {
                  self.dialog=false
                  self.errorMessage=error.response.data.error.message
                }else if(error.response.data.error_in){
                  self.dialog=false
                  let error_in=error.response.data.error_in
                  console.log(error_in)
                  for(let x=0;x<7;x++){
                    for(let y=0;y<=self.counter[x];y++){
                      self.error_in[x].push(false)
                    }
                  }
                  console.log(self.error_in)
                  error_in.forEach((element,index)=>{
                    this.error_in[element.day][element.slot]=true
                  })
                  console.log(self.error_in)
                }
        })
      }
  },
  updated:function(){
      this.setTeacherTime()
      this.setScrollPositions(this.selectedTab)
  },
  components: {
    VueDawa,
    Datepiker,
    DateDropdown,
    PulseLoader
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/WidgetComponents/AddNewTeacher.vue